export const roundCurrency = (value: number) => Math.round(value * 100) / 100;

export const calculateAiSplitAllocatedTotal = (
  parentAmount: number,
  childAmounts: number[],
) =>
  roundCurrency(
    Number(parentAmount || 0) +
      childAmounts.reduce((total, amount) => total + Number(amount || 0), 0),
  );
